"use client";

import { useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { Copy, Check, Triangle as AlertCircle } from "lucide-react";

import { AUTO_CLOSE_TIMES } from "@/shared/config";
import { Button } from "@/shared/ui/buttons/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/ui/cards/card";
import { Badge } from "@/shared/ui/data-display/badge";

export function TwitchDebugInfo() {
  const tUi = useTranslations("Ui");
  const [currentHost, setCurrentHost] = useState<string>("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentHost(window.location.host);
    }
  }, []);

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), AUTO_CLOSE_TIMES.FAST);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const twitchEmbedUrl = `https://player.twitch.tv/?channel=test&parent=${currentHost}`;

  return (
    <Card className="mb-4 border-yellow-200 bg-yellow-50 dark:bg-yellow-950/20">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-sm">
          <AlertCircle className="h-4 w-4 text-yellow-600" />
          {tUi("twitchDebugInfo.otladochnayaInformatsiyaTwitch")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-1 gap-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">{tUi("twitchDebugInfo.tekuschiyDomen")}</span>
            <Badge variant="outline" className="text-xs">
              {currentHost || "localhost:3000"}
            </Badge>
          </div>

          <div className="space-y-2">
            <span className="text-sm font-medium">{tUi("twitchDebugInfo.urlDlyaVstraivaniya")}</span>
            <div className="flex items-center gap-2">
              <code className="text-xs bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded flex-1 break-all">
                {twitchEmbedUrl}
              </code>
              <Button
                size="sm"
                variant="outline"
                onClick={() => copyToClipboard(twitchEmbedUrl)}
                className="h-7 w-7 p-0"
              >
                {copied ? (
                  <Check className="h-3 w-3" />
                ) : (
                  <Copy className="h-3 w-3" />
                )}
              </Button>
            </div>
          </div>
        </div>

        <div className="text-xs text-yellow-700 dark:text-yellow-300 bg-yellow-100 dark:bg-yellow-900/30 p-2 rounded">
          <strong>{tUi("twitchDebugInfo.dlyaVstraivaniya")}</strong> Добавьте домен{" "}
          <code>{currentHost || "localhost:3000"}</code> {tUi("twitchDebugInfo.vTwitchDeveloperConsole")}
        </div>
      </CardContent>
    </Card>
  );
}
